module.exports = __webpack_public_path__ + "static/native_energy-fe9400c625dc35e99ca2c0077d33ad38.png";